import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    listTools: [],
    listConnections: [],
    listGuides: [],
    guideChat: {
      messages: []
    },
    guideChatId: null
  },
  getters: {
    listTools(state) {
      return state.listTools;
    },
    listConnections(state) {
      return state.listConnections;
    },
    listGuides(state) {
      return state.listGuides;
    },
    guideChat(state) {
      return state.guideChat;
    }
  },
  actions: {
    getListTools({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let companiesRef = db.collection("companies");
        let tools = [];
        companiesRef.onSnapshot(querySnapshot => {
          return querySnapshot.forEach(doc => {
            return db
              .collection(`${doc.ref.path}/tools`)
              .where("_is_active", "==", true)
              .onSnapshot(snapshot => {
                snapshot.forEach(doc => {
                  tools.push({
                    ...doc.data(),
                    toolId: doc.id,
                    toolRef: doc.ref
                  });
                });
              });
          });
        });
        commit("SET_LIST_TOOLS", tools);
        res(tools);
      });
    },
    getListConnections({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let connectionsRef = db.collection("listings/connections/items");
        let connections = [];
        connectionsRef
          .where("_is_active", "==", true)
          .get()
          .then(snap => {
            snap.forEach(doc => {
              console.log(doc);
              connections.push({
                ...doc.data(),
                connectionId: doc.id,
                connectionRef: doc.ref
              });
            });
            commit("SET_LIST_CONNECTIONS", connections);
            res(connections);
          });
        // return db
        //   .collection(`${doc.ref.path}/tools`)
        //   .where("_is_active", "==", true)
        //   .onSnapshot(snapshot => {
        //     snapshot.forEach(doc => {
        //       connections.push({
        //         ...doc.data(),
        //         toolId: doc.id,
        //         toolRef: doc.ref
        //       });
        //     });
        //   });
        // res(tools);
      });
    },
    getListGuides({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsGuidesRef = db.collection("listings/guides/items");
        let guides = [];
        listingsGuidesRef
          //.where("is_active", "==", true) -- //@TODO _ Should I pull all or pass status
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
              guides.push(doc.data());
            });
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
        commit("SET_LIST_GUIDES", guides);
        res(guides);
      });
    },
    getGuideById({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guide = null;
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        listingGuideRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              guide = doc.data();
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
            res(guide);
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    getGuideByProfileName({ commit, state }, profileName) {
      // debugger;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const guideRef = db.collection("listings/guides/items");

        return guideRef
          .where("profile.username", "==", profileName)
          .get()
          .then(snap => {
            if (snap.docs.length > 0) {
              res({ ...snap.docs[0].data(), userId: snap.docs[0].id });
            } else {
              res(null);
            }
          })
          .catch(err => {
            console.log("error in getting guide data: ", err);
            rej(err);
          });
      });
    },
    guideApply({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .set({
            _created_at: new Date(),
            user: profile //The user information- profile data is what is saved in guide
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    guideRequestProfileUpdate({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        let guide_profile = profile._dashboards.guide;

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .update({
            _updated_at: new Date(),
            profile_update: guide_profile //The user information- profile data is what is saved in guide
          })
          .then(function() {
            console.log("User Successfully Requested for Updated Profile!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    adminGuideApproveApplication(
      { commit, state },
      { admin: profile, guideUserId: userId }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(userId);
        return listingGuideRef
          .update({
            _approved_at: new Date(),
            _approved_by: `users/${profile.userId}`,
            status: "approved"
          })
          .then(function() {
            console.log("User Successfully Approved!");
            res(true);
            //Now Complete SetUp of Approval
            // let send = firebase
            //   .functions()
            //   .httpsCallable("guideAppApprovalSetUp");
            // send({ guideUserId: userId })
            //   .then(data => {
            //     console.log("successfully sent email and setup data", res);
            //   })
            //   .catch(function(error) {
            //     console.error("Error setting up guide: ", error);
            //     rej(error);
            //   });
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    adminGuideApproveUpdate(
      { commit, state },
      { admin: profile, guide: guide_profile }
    ) {
      return new Promise((res, rej) => {
        // debugger;
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(guide_profile.user.userId);
        return listingGuideRef
          .update({
            _update_approved_at: new Date(),
            _update_approved_by: `users/${profile.userId}`,
            profile: guide_profile.profile_update,
            profile_update: null
          })
          .then(function() {
            console.log("User Successfully Updated!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    adminGuideApproveListing(
      { commit, state },
      { admin: profile, guideUserId: userId }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(userId);
        return listingGuideRef
          .update({
            _listing_at: new Date(),
            _listed_by: `users/${profile.userId}`,
            status: "active" //Create a Guides section for user
          })
          .then(function() {
            console.log("User Successfully Listed!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    updateGuideInfo({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/guides/items")
          .doc(profile.userId);
        let guide_profile = profile._dashboards.guide;

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .update({
            _updated_at: new Date(),
            profile: guide_profile //The user information- profile data is what is saved in guide
          })
          .then(function() {
            console.log("Guide Info Successfully updated!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating Guide Info: ", error);
            rej(error);
          });
      });
    },
    getGuideAvailability({ commit, state }, guideId) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        const timesRef = db.doc(
          `listings/guides/items/${guideId}/guide_info/__guide_availability`
        );
        return timesRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let times = [...doc.data().timings];
              res(times);
            } else {
              res([]);
            }
          })
          .catch(err => {
            console.log("Error in getting available times: ", err);
            rej(err);
          });
      });
    },
    updateGuideAvailability({ commit, state }, { id, mode, time, guideId }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        const timesRef = db.doc(
          `listings/guides/items/${guideId}/guide_info/__guide_availability`
        );
        return timesRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let times = [...doc.data().timings];
              if (mode == "updated") {
                let timeToUpdate = {};
                times.forEach(aTime => {
                  if (aTime.id == id) {
                    timeToUpdate = aTime;
                  }
                });
                let updatedTimes = times.filter(aTime => aTime.id !== id);
                timesRef
                  .update({
                    timings: firebase.firestore.FieldValue.arrayRemove(
                      timeToUpdate
                    )
                  })
                  .then(() => {
                    return timesRef
                      .update({
                        timings: [...updatedTimes, { ...time }]
                      })
                      .then(() => {
                        console.log("successfully updated time");
                        res(true);
                      });
                  });
              } else if (mode == "deleted") {
                let timeToDelete = {};
                times.forEach(aTime => {
                  if (aTime.id == id) {
                    timeToDelete = aTime;
                  }
                });
                return timesRef
                  .update({
                    timings: firebase.firestore.FieldValue.arrayRemove(
                      timeToDelete
                    )
                  })
                  .then(() => {
                    console.log("successfully updated time");
                    res(true);
                  });
              } else if (mode == "inserted") {
                return timesRef
                  .update({
                    timings: [...times, { ...time }]
                  })
                  .then(() => {
                    console.log("successfully saved time");
                    res(true);
                  });
              }
            } else {
              return timesRef
                .set({
                  _created_at: new Date(),
                  timings: [{ ...time }]
                })
                .then(() => {
                  console.log("successfully saved time");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in updating times: ", err);
            rej(err);
          });
      });
    },
    checkGuideProfileName({ commit, state }, profileName) {
      let userName = profileName.trim().toLowerCase();
      return new Promise((res, rej) => {
        let nameExists = false;
        const db = firebase.firestore();
        let guides = db
          .collection("listings")
          .doc("guides")
          .collection("items");
        return guides
          .get()
          .then(querySnapshot => {
            querySnapshot.docs.forEach(doc => {
              if (doc.data().profile && doc.data().profile.username) {
                if (userName == doc.data().profile.username) {
                  nameExists = true;
                }
              }
            });
            if (nameExists) {
              res("already taken");
            } else {
              res("accepted");
            }
          })
          .catch(error => {
            console.log(error);
            rej(error);
          });
      });
    },
    getGuideChatOld({ commit, state }, { guideId, identity, sessionId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const chatRef = db.collection(
          `listings/guides/items/${guideId}/guide_info/__guide_messages/messages`
        );
        return chatRef
          .where("sessionId", "==", sessionId)
          .get()
          .onSnapshot(snap => {
            if (snap.docs.length > 0) {
              commit("SET_GUIDE_CHAT", snap.docs[0].data());
              commit("SET_GUIDE_CHAT_ID", snap.docs[0].id);
              res(snap.docs[0].data());
            } else {
              let chatDoc = chatRef.doc();
              chatDoc
                .set({
                  _created_at: new Date(),
                  identity: identity,
                  sessionId: sessionId,
                  messages: []
                })
                .then(doc => {
                  chatDoc.onSnapshot(doc => {
                    commit("SET_GUIDE_CHAT", doc.data());
                    commit("SET_GUIDE_CHAT_ID", doc.id);
                    res(doc.data());
                  });
                });
            }
          })
          .catch(err => {
            console.log("error in getting guide messages:", err);
          });
      });
    },
    getGuideChat({ commit, state }, { guideId, identity, sessionId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const chatRef = db.doc(
          `listings/guides/items/${guideId}/guide_info/__guide_messages/messages/${sessionId}`
        );

        chatRef
          .get()
          .then(doc => {
            if (doc.exists) {
              chatRef.onSnapshot(doc => {
                commit("SET_GUIDE_CHAT", doc.data());
                commit("SET_GUIDE_CHAT_ID", doc.id);
                res(doc.data());
              });
            } else {
              chatRef
                .set({
                  _created_at: new Date(),
                  identity: identity,
                  messages: []
                })
                .then(doc => {
                  chatRef.onSnapshot(doc => {
                    commit("SET_GUIDE_CHAT", doc.data());
                    commit("SET_GUIDE_CHAT_ID", doc.id);
                    res(doc.data());
                  });
                });
            }
          })
          .catch(err => {
            console.log("error in saving list guide sessions 3:", err);
          });
      });
    },
    addGuideMsg({ commit, state }, { guideId, message }) {
      const db = firebase.firestore();
      let chatRef = db.doc(
        `listings/guides/items/${guideId}/guide_info/__guide_messages/messages/${state.guideChatId}`
      );

      chatRef
        .update({
          messages: firebase.firestore.FieldValue.arrayUnion(message)
        })
        .then(function(data) {
          console.log("Data has been logged");
        })
        .catch(function(error) {
          console.error("Error adding guide message: ", error);
        });
    },
    getBloggerById({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guide = null;
        let listingGuideRef = db
          .collection("listings/bloggers/items")
          .doc(profile.userId);
        listingGuideRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              guide = doc.data();
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
            }
            res(guide);
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
            rej(error);
          });
      });
    },
    bloggerApply({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingGuideRef = db
          .collection("listings/bloggers/items")
          .doc(profile.userId);

        // Set the "capital" field of the city 'DC'
        return listingGuideRef
          .set({
            _created_at: new Date(),
            user: profile //The user information- profile data is what is saved in guide
          })
          .then(function() {
            console.log("User Successfully Applied!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    checkBloggerProfileName({ commit, state }, profileName) {
      let userName = profileName.trim().toLowerCase();
      return new Promise((res, rej) => {
        let nameExists = false;
        const db = firebase.firestore();
        let guides = db
          .collection("listings")
          .doc("bloggers")
          .collection("items");
        return guides
          .get()
          .then(querySnapshot => {
            querySnapshot.docs.forEach(doc => {
              if (doc.data().profile && doc.data().profile.username) {
                if (userName == doc.data().profile.username) {
                  nameExists = true;
                }
              }
            });
            if (nameExists) {
              res("already taken");
            } else {
              res("accepted");
            }
          })
          .catch(error => {
            console.log(error);
            rej(error);
          });
      });
    },
    updateBloggerInfo({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db
          .collection("listings/bloggers/items")
          .doc(profile.userId);
        let blogger_profile = profile._dashboards.blogger;

        // Set the "capital" field of the city 'DC'
        return listingBlogRef
          .update({
            _updated_at: new Date(),
            profile: blogger_profile
          })
          .then(function() {
            console.log("Blogger Info Successfully updated!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating Blogger Info: ", error);
            rej(error);
          });
      });
    },
    submitBloggerBlog({ commit, state }, { blog, blogger }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingBlogRef = db.collection("listings/blogs/items").doc(blog.id);
        return listingBlogRef
          .set({
            _created_at: blog._created_at,
            _submitted_at: new Date(),
            id: blog.id,
            docURL: blog.docURL,
            status: "submitted",
            doc: {
              title: blog.title,
              synopsis: blog.synopsis,
              spheres: blog.spheres,
              seo: blog.seo
            },
            blogger: blogger
          })
          .then(function() {
            console.log("Blog Successfully submitted!");
            res(true);
          })
          .catch(function(error) {
            console.error("Error submittig Blogg", error);
            rej(error);
          });
      });
    },
    getListCharities({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let charitiesRef = db.collection("listings").doc("charities");
        return charitiesRef
          .get()
          .then(doc => {
            res(doc.data().list);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating Blogger Info: ", error);
            rej(error);
          });
      });
    }
  },
  //synchronous
  mutations: {
    SET_LIST_TOOLS(state, listTools) {
      if (listTools) {
        state.listTools = listTools;
      } else {
        state.listTools = [];
      }
    },
    SET_LIST_CONNECTIONS(state, connections) {
      if (connections) {
        state.listConnections = connections;
      } else {
        state.listConnections = [];
      }
    },

    SET_LIST_GUIDES(state, listGuides) {
      if (listGuides) {
        state.listGuides = listGuides;
      } else {
        state.listGuides = [];
      }
    },
    SET_GUIDE_CHAT_ID(state, id) {
      state.guideChatId = id;
    },
    SET_GUIDE_CHAT(state, chat) {
      state.guideChat = chat;
    }
  }
};
